import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionScope } from "@verbleif/lib/src/composables/Api/Type/UserPermissions/userPermission.enum";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class UserGroupVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationUsergroupCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationUsergroupCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationUsergroupReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationUsergroupRead,
      scope: PermissionScope.USER_GROUP,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationUsergroupDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationUsergroupDelete,
      scope: PermissionScope.USER_GROUP,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationUsergroupUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationUsergroupUpdate,
      scope: PermissionScope.USER_GROUP,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationUsergroupCreateany,
        PermissionAttributesEnum.GlobalOperationUsergroupUpdateany,
        PermissionAttributesEnum.GlobalOperationUsergroupDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationUsergroupCreate,
        PermissionAttributesEnum.ContextOperationUsergroupUpdate,
        PermissionAttributesEnum.ContextOperationUsergroupDelete,
      ],
      scope: PermissionScope.USER_GROUP,
    });
  };
}
